var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.108,
    height: 27,
    viewBox: "0 0 35.108 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-newspaper-3218907",
    transform: "translate(-9 -41.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(7.077 36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9486",
    "data-name": "Path 9486",
    d: "M36.249,5.8H7.792a.782.782,0,0,0-.782.782V9.692H2.705a.782.782,0,0,0-.782.782V32.015a.782.782,0,0,0,.782.782H36.249a.782.782,0,0,0,.782-.782V6.579a.782.782,0,0,0-.782-.782ZM3.5,31.234H3.487V11.255H7.011V29.591a1.645,1.645,0,0,1-1.643,1.643Zm31.968,0H8.107a3.172,3.172,0,0,0,.468-1.643V7.36H35.468Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9487",
    "data-name": "Path 9487",
    d: "M13.078,31.744h9.936a.782.782,0,0,0,.782-.782v-7a.782.782,0,0,0-.782-.782H13.078a.782.782,0,0,0-.782.782v7a.782.782,0,0,0,.782.782Zm.782-7h8.373v5.432H13.859Z",
    transform: "translate(-2.265 -3.796)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9488",
    "data-name": "Path 9488",
    d: "M29.45,24.749h9.38a.782.782,0,0,0,0-1.563H29.45a.782.782,0,0,0,0,1.563Z",
    transform: "translate(-5.839 -3.796)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9489",
    "data-name": "Path 9489",
    d: "M29.45,29.224h9.38a.782.782,0,0,0,0-1.563H29.45a.782.782,0,0,0,0,1.563Z",
    transform: "translate(-5.839 -4.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9490",
    "data-name": "Path 9490",
    d: "M29.45,33.7h9.38a.782.782,0,0,0,0-1.563H29.45a.782.782,0,1,0,0,1.563Z",
    transform: "translate(-5.839 -5.75)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu9);
export default __webpack_public_path__ + "static/media/menu-9.c5fb73b128a8eb742cc0bf536605c100.svg";
export { ForwardRef as ReactComponent };